<template>
  <v-row no-gutters justify="center" align="center" style="height: 100vh;">
    <v-overlay :opacity="0.8" v-model="loading">
      <v-row no-gutters justify="center" align="center" class="fill-height">
        <v-col cols="auto">
          <v-progress-circular indeterminate color="white" :width="8" :size="100"></v-progress-circular>
        </v-col>
      </v-row>
    </v-overlay>
    <template v-if="page === 1">
      <v-btn
          dark
          outlined
          absolute
          top
          class="rounded-lg"
          style="left: 15px;"
          :disabled="isAnimating"
          @click="goBackToContactSessionSelector()">
        Contact Sessions
      </v-btn>
      <v-btn
          dark
          outlined
          absolute
          top
          class="rounded-lg"
          style="left: 215px;"
          :disabled="isAnimating"
          @click="resetMainState()"
      >Reset
      </v-btn>
    </template>
    <v-col cols="auto">
      <contact-session-selector
          :sessions="sessions"
          v-show="page === 0"
          @select="selectSession($event)"
      ></contact-session-selector>
      <candidate-selector
          ref="candidateSelector"
          :candidates="candidates"
          v-show="page === 1"
          @animating="setAnimatingState($event)"
      ></candidate-selector>
    </v-col>
  </v-row>
</template>

<script>
import ContactSessionSelector from "@/views/Tools/GeneralTools/ContactSessionSelector";
import CandidateSelector from "@/views/Tools/GeneralTools/CandidateSelector";
import {v4 as uuid} from 'uuid';

export default {
  name: "ContactSessionCandidates",
  components: {
    ContactSessionSelector,
    CandidateSelector,
  },
  data: () => ({
    page: 0,
    sessions: [],
    candidates: [],
    isAnimating: false,
    loading: false,
  }),
  methods: {
    getContactSessions() {
      this.loading = true;

      this.$http.get(`/contactsessions`).then(
          (resp) => {
            this.sessions = resp.data;

            this.loading = false;
          }
      );
      // this.sessions = require('@/assets/text/general_tools_candidate_selector.json').sessions
      // this.loading = false
    },
    getSessionCandidates(session) {
      // console.log(session);
      this.loading = true;

      this.$http.get(`/contactsessions/${session.contactsessionid}/persons`).then(
          (resp) => {
            this.candidates = resp.data.map((candidate) => {
              return {
                ...candidate,
                personid: uuid(),
              };
            });

            this.goToCandidateSelector();
            this.loading = false;
          }
      );
      // this.candidates = require('@/assets/text/general_tools_candidate_selector.json').candidates
      // this.goToCandidateSelector();
      // this.loading = false
    },
    selectSession(session) {
      this.getSessionCandidates(session)
    },
    goToCandidateSelector() {
      this.page++;
    },
    goBackToContactSessionSelector() {
      this.resetMainState();
      this.page--;
    },
    resetMainState() {
      if (this.$refs['candidateSelector']) {
        this.$refs.candidateSelector.resetMainSelected();
        this.$refs.candidateSelector.moveToNextCandidate();
      }
    },
    setAnimatingState(animating) {
      this.isAnimating = animating;
    },
  },
  mounted() {
    this.getContactSessions();
  },
}
</script>

<style scoped>

</style>